/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useEffect } from 'react';
import OneSignalReact from 'react-onesignal';
import { useDispatch, useSelector } from 'react-redux';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { getLocalStorageValue } from 'Utils/UtilityFunctions';
import { FEED_GILROY_ROUTE, FEED_SPOTLIGHT_ROUTE, SAFARI_NOTIFY_ID } from 'Utils/Constants';
import { selectShowChatbot, selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import { actions as alertActions } from '../../../Slice/AlertsSlice';
import { actions as GlobalSearchContentActions } from '../../../Slice/GlobalSearchContentSlice';

const OneSignal: React.FC = function OneSignal() {
  const ONESIGNAL_KEY: string | undefined = process.env.REACT_APP_ONESIGNAL_KEY;
  const dispatch = useDispatch();
  const navigate: NavigateFunction = useNavigate();
  const chatbotAllowed = useSelector(selectShowChatbot);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const isOneSignalApiCall = !!getLocalStorageValue('onesignalcall');

  function saveDeviceToken() {
    OneSignalReact.isPushNotificationsEnabled((isEnabled) => {
      if (isEnabled) {
        OneSignalReact.getUserId((userId) => {
          if (userId) {
            const data = {
              deviceToken: userId,
              appName: 'xiq-webapp',
            };
            dispatch(GlobalSearchContentActions.getDeviceTokenSaved(data));
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  const redirectToArticle = (id: number) => {
    if (chatbotAllowed && showGlobalGilroy) {
      navigate(`${FEED_GILROY_ROUTE}?articleId=${id}`);
    } else {
      navigate(`${FEED_SPOTLIGHT_ROUTE}?articleId=${id}`);
    }
    // navigate(`/article?id=${id}`, { state: { isPushNotification: true } });
  };

  function onSubscribeButtonClicked() {
    saveDeviceToken();
  }

  const initializeOneSignal = () => {
    if (ONESIGNAL_KEY) {
      OneSignalReact.init({
        appId: ONESIGNAL_KEY,
        safari_web_id: SAFARI_NOTIFY_ID,
        autoRegister: true,
        welcomeNotification: {
          disable: true,
        },
        notifyButton: {
          enable: true,
        },
        allowLocalhostAsSecureOrigin: true,
        notificationClickHandlerMatch: 'origin',
        notificationClickHandlerAction: 'focus',
        externalUserId: getLocalStorageValue('email'),
      }).then(() => {
        if (!isOneSignalApiCall) {
          saveDeviceToken();
        }

        OneSignalReact.setDefaultTitle('xiQ').catch((error) => {
          console.log(error);
        });

        OneSignalReact.on('notificationDisplay', (event: any) => {
          // update count on Alert Tab if (data.type === 'custom_notification') else check
          if (event.data.type === 'custom_notification') {
            const { count } = event.data;
            dispatch(GlobalSearchContentActions.updateArticleCount(count));
          }
          // for live person
        });

        OneSignalReact.on('addListenerForNotificationOpened', (event: any) => {
          // update count on Alert Tab if (data.type === 'custom_notification') else check
          if (event.data.type === 'custom_notification') {
            const { count } = event.data;
            dispatch(GlobalSearchContentActions.updateArticleCount(count));
          }
          // for live person
        });

        OneSignalReact.isPushNotificationsEnabled((isEnabled) => {
          if (!isEnabled) {
            OneSignalReact.on('register', () => {
              // Code Here! if User got registered
              saveDeviceToken();
              // call dispatch to save token api call.
            });
          }
        }).catch((error) => {
          console.log(error);
        });

        OneSignalReact.on('subscriptionChange', (isSubscribed) => {
          if (isSubscribed) {
            onSubscribeButtonClicked();
          } else if (!isSubscribed) {
            OneSignalReact.removeExternalUserId()
              .then((res) => console.log('Remove External User id Successfully', res))
              .catch((err) => console.log('Remove External User id Failed', err));
          }
        });
        OneSignalReact.addListenerForNotificationOpened((event: any) => {
          if (event.data.type === 'custom_notification') {
            dispatch(alertActions.setDrawerState());
          } else if (event.data.type === 'article') {
            const { data } = event;
            if (data && data.articleId && data.articleId > 0) {
              redirectToArticle(data.articleId);
            }
          }
        }).catch((errListener) => { console.log('Error One Signal ', errListener); });
      }).catch((error) => {
        console.log(error);
      });
    }
  };

  useEffect(() => {
    console.log('initializaing One Signal');
    initializeOneSignal();
  }, []);

  return (
    <>
    </>
  );
};

export default OneSignal;
